import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { Link as GenericLink } from '~/shared/components/Link';
import { breakpoints } from '~/theme';

export const CategoryListItem = styled.li(({ theme }) => ({
    fontSize: theme.fontSizes.rat,
    lineHeight: theme.lineHeights.dog,
    paddingBottom: theme.space[4],
}));

export const Link = styled(GenericLink)<{ isActive?: boolean }>(
    () => ({
        ':hover, :focus, :active': {
            textDecoration: 'underline',
        },
    }),

    ifProp('isActive', () => ({
        textDecoration: 'underline',
    })),
);

export const CategoryList = styled.ul(({ theme }) => ({
    width: '100%',
    whiteSpace: 'nowrap', // Prevent text from wrapping to the next line
    overflowX: 'auto',
    display: 'grid',
    gridAutoFlow: 'column',
    gap: theme.space[5],
    marginTop: `${theme.space[4]}`,
    scrollbarWidth: 'none',
    '::-webkit-scrollbar': {
        display: 'none',
    },

    [breakpoints.sm]: {
        maxWidth: 250,
        display: 'block',
        gridColumn: '1 / span 2',
        gap: 0,
        gridAutoFlow: 'row',
        marginTop: `${theme.space[5]}`,
    },
}));
